import React, {useState, useEffect, useRef, useCallback, useReducer, useMemo} from 'react';
import {useDispatch, useMappedState} from 'redux-react-hook'
import styled from 'styled-components';
import {Textarea} from "../../ira/ui/Inputs";
import {BlueButton} from "../../ira/ui/Buttons";
import ChatGPTAPI from "../../../api/ChatGPTAPI";

export default function CommentTool(props) {
    const [loading, setLoading] = useState(false);
    const [userAnswer, setUserAnswer] = useState('');
    const [correctAnswer, setCorrectAnswer] = useState('');
    const [extra, setExtra] = useState('');
    const [result, setResult] = useState(undefined);

    return (
        <Wrapper>

            <Row className={'field'}>
                <Label>
                    Правильный ответ
                </Label>
                <Textarea value={correctAnswer}
                          style={{
                              lineHeight: '20px',
                              minHeight: '60px'
                          }}
                          placeholder={''}
                          onChange={(evt) => {
                              setCorrectAnswer(evt.target.value);
                              setResult(undefined);
                          }}/>
            </Row>

            <Row className={'field'}>
                <Label>
                    Ответ ученика
                </Label>
                <Textarea value={userAnswer}
                          style={{
                              lineHeight: '20px',
                              minHeight: '60px'
                          }}
                          placeholder={''}
                          onChange={(evt) => {
                              setUserAnswer(evt.target.value);
                              setResult(undefined);
                          }}/>
            </Row>

            <Row className={'field'}>
                <Label>
                    Дополнительная инструкция
                </Label>
                <Textarea value={extra}
                          style={{
                              lineHeight: '20px',
                              minHeight: '60px'
                          }}
                          placeholder={''}
                          onChange={(evt) => {
                              setExtra(evt.target.value);
                              setResult(undefined);
                          }}/>
            </Row>

            {result != undefined || (userAnswer == '' || correctAnswer == '') ? null :
                <Row>
                    {loading == true ? 'Загрузка...' :
                        <BlueButton onClick={async () => {
                            setLoading(true);
                            setResult(undefined);
                            let pld = await ChatGPTAPI.getTeacherComment(correctAnswer, userAnswer, extra);
                            setResult(pld);
                            setLoading(false);
                        }}>
                            Сгенерировать ответ
                        </BlueButton>
                    }
                </Row>
            }


            {result == undefined ? null :
                <div>
                    <Label>
                        Результат:
                    </Label>
                    <Textarea value={result}
                              style={{
                                  lineHeight: '20px',
                                  minHeight: '300px'
                              }}
                              placeholder={''}
                    />

                    {/*<div dangerouslySetInnerHTML={{__html: result.replace(/\n/g, '<br/>')}}></div>*/}
                </div>
            }

        </Wrapper>
    );
}

const Wrapper = styled.div`

`;

const Row = styled.div`
  margin-bottom: 5px;
`;

const Label = styled.div`
  font-weight: bold;
`;
